import { isAuthProviderError } from '@apps/acquisitionFunnels/createWedding/utils';
import { useAuth } from '@shared/components/AuthProvider';
import { useTranslation } from '@shared/core';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import { useFieldErrors } from '@shared/hooks/useFieldErrors';
import { useAuthRedirectURLs } from '../useAuthRedirectURLs';
import { usePublicCardShopTelemetry } from '@apps/card/routes/PublicShop/PublicShop.telemetry';
import { isAuthSetupError } from '@static/js/authFailure';

type CreateAccountFields = {
  email: string;
  password: string;
};

// TODO -- add telemetry.
const useCreateAccountController = () => {
  const authProvider = useAuth();
  const [submissionError, setSubmissionError] = useState<string>('');
  const { t2, tq } = useTranslation('createWedding');
  const { createOrSignupCtaClicked } = usePublicCardShopTelemetry();

  const formikErrors = t2('createAccount', 'errors');

  const generateAuthRedirectURls = useAuthRedirectURLs();

  const formik = useFormik<CreateAccountFields>({
    initialValues: { email: '', password: '' },
    validationSchema: Yup.object({
      email: Yup.string().email(formikErrors.emailValid).required(formikErrors.emailRequired),
      password: Yup.string().required(formikErrors.passwordRequired),
    }).required(),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async ({ email, password }) => {
      try {
        createOrSignupCtaClicked('createAccount');
        const redirectURLs = generateAuthRedirectURls('accountcreated', 'accountfailure');
        await authProvider.loginManager.signupWithUsernameAndPassword(email, password, redirectURLs.success, redirectURLs.failure);
      } catch (err) {
        if (isAuthProviderError(err)) {
          setSubmissionError(err.description);
        } else if (isAuthSetupError(err)) {
          setSubmissionError(tq`There was an error creating your account. Please try again.`);
        }
      }
    },
  });
  const getFieldErrorProps = useFieldErrors<CreateAccountFields>(formik);

  return {
    formik,
    submissionError,
    getFieldErrorProps,
  };
};

export default useCreateAccountController;
